import { once, throttle } from 'lodash';

import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';

import { composeSubscriber } from './module';

export const identifyOnStartup = (selectIsReady, selectTrackingInitializationEffectCreator) => {
  return composeSubscriber({
    selector: createStructuredSelector({
      isReady: selectIsReady,
      handler: createSelector(
        createSelector(
          selectTrackingInitializationEffectCreator,
          (trackingInitializationCreator: any) => {
            return once(state => {
              trackingInitializationCreator(state);
            });
          }
        ),
        s => s
      )
    }),
    onChange: ({ isReady, handler }) => {
      if (isReady) {
        handler();
      }
    }
  });
};

export const TRACKING_INTERVAL: number = 500;

export const trackCollectedActions = (
  selectIsReady,
  selectAnalyticsState,
  clearTrackingActions,
  selectTrackWithState
) =>
  composeSubscriber({
    selector: createStructuredSelector({
      isReady: selectIsReady,
      actionsToTrack: selectAnalyticsState,
      trackWithState: selectTrackWithState
    }),
    onChange: throttle(({ isReady, actionsToTrack, trackWithState }) => {
      if (!isReady) {
        return;
      }

      if (actionsToTrack.size < 1) {
        return;
      }

      clearTrackingActions();
      // This linting rule doesn't take into account that other arguments are passed
      //tslint:disable:no-unnecessary-callback-wrapper
      actionsToTrack.forEach(action => trackWithState(action));
      //tslint:enable:no-unnecessary-callback-wrapper
    }, TRACKING_INTERVAL)
  });
